// src/lib/env.ts
import { resolveApiBaseUrl } from './resolve-api-base-url';

export const env = {
  apiBaseUrl: import.meta.env.DEV
    ? '/api/v1'
    : resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL, ''),
} as const;
